import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';

export const EMPLOYEE_IMPORT_HEADERS = [
  'User Code', 'Name', 'Barcode', 'Organization', 'Position', 'Job Level',
  'Join Date', 'Resign Date', 'Employee Status', 'End Date', 'Sign Date',
  'Email', 'Birthdate', 'Age', 'Birth Place', 'Current Address', 'Address',
  'NPWP', 'PTKP Status', 'Employee Tax Status', 'Tax Config', 'Bank Name',
  'Bank Account', 'Account Name', 'BPJS Ketenagakerjaan', 'BPJS Kesehatan',
  'NIK', 'Mobile Phone', 'Phone', 'Branch Name', 'Parent Branch Name',
  'Religion', 'Gender', 'Marital Status', 'Blood Type', 'Nationality Code',
  'Currency', 'Work Duration', 'Payment Schedule', 'Approval Line', 'Manager',
  'Grade', 'Class', 'Picture', 'Cost Center', 'Cost Center Category', 'SBU',
  'NPWP Old', 'Passport', 'Passport Expiration Date',
  'Jenis Dok. Referensi Bukti Potong', 'Nomor Dok. Referensi Bukti Potong',
  'Tanggal Dok. Referensi Bukti Potong', 'Nama PT', 'User Role',
  'Education Level', 'Education Institution', 'Education Major',
  'Education Start Year', 'Education End Year', 'Education GPA', 'Education Notes'
];

const normalizeHeader = (value) => String(value || '').trim().toLowerCase();

export const validateEmployeeImportFile = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();

  reader.onload = (event) => {
    try {
      const workbook = XLSX.read(event.target.result, { type: 'array' });
      if (workbook.SheetNames.length !== 1) {
        reject(new Error('File harus hanya memiliki satu sheet.'));
        return;
      }

      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '' });
      const headers = (rows[0] || []).map(normalizeHeader);
      const missing = EMPLOYEE_IMPORT_HEADERS.filter(
        (header) => !headers.includes(normalizeHeader(header))
      );

      if (missing.length > 0) {
        reject(new Error(`Header tidak lengkap: ${missing.join(', ')}`));
        return;
      }

      resolve(true);
    } catch (error) {
      reject(new Error('File Excel tidak dapat dibaca atau formatnya rusak.'));
    }
  };

  reader.onerror = () => reject(new Error('File gagal dibaca.'));
  reader.readAsArrayBuffer(file);
});

export const downloadEmployeeImportTemplate = () => {
  const worksheet = XLSX.utils.aoa_to_sheet([EMPLOYEE_IMPORT_HEADERS]);
  worksheet['!freeze'] = { xSplit: 0, ySplit: 1 };
  worksheet['!cols'] = EMPLOYEE_IMPORT_HEADERS.map((header) => ({
    wch: Math.min(Math.max(header.length + 2, 14), 34),
  }));

  EMPLOYEE_IMPORT_HEADERS.forEach((_, index) => {
    const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
    worksheet[cellRef].s = {
      font: { bold: true, color: { rgb: 'FFFFFF' } },
      fill: { fgColor: { rgb: '1F4E78' } },
      alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } },
      },
    };
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Employee');
  const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  saveAs(
    new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
    'TEMPLATE_IMPORT_EMPLOYEE_WITH_EDUCATION.xlsx'
  );
};
